export default "/50f517735fec46580f19aae3e56e9fe21614ea75/6ca19e876096cae3e2ee3e269668428e.svg";